import { Box, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { Base } from ".";
import TabNavButton from "../../types/tabNavButton";

interface Props {
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
  tabs: TabNavButton[];
  activeBackgroundColor?: string;
  disabled?: boolean;
  disabledIndex?: number[];
  disabledMessage?: (step?: TabNavButton) => void;
}

const TabBottomNavigation: React.FC<Props> = (props) => {
  const { tabs, activeTab } = props;
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      {!sm && <Base.Tabs {...props} />}
      <Box
        sx={{
          border: {
            md: `1px solid ${theme.palette.primary.main}`,
            xs: "none",
          },
          backgroundColor: theme.palette.background.paper,
          paddingTop: { xs: 0, md: "20px" },
          paddingX: { xs: 0, sm: "20px" },
          maxHeight: "1710px",
          overflowY: "scroll",
          borderBottomLeftRadius: "5px",
          borderBottomRightRadius: "5px",
          mb: 5,
        }}
      >
        {tabs[activeTab].element}
      </Box>
      {sm && <Base.BottomNav {...props} />}
    </>
  );
};

export default TabBottomNavigation;
